import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

/**
 * Returns true when running inside Capacitor native shell (iOS/Android).
 * Returns false for browser and PWA.
 */
export function isNative() {
	return Capacitor.isNativePlatform();
}

/**
 * Thin wrapper around Capacitor Preferences for JWT storage on native.
 * All methods are no-ops on web (guarded by isNative check at call site).
 */
export const NativeStorage = {
	async getToken() {
		const { value } = await Preferences.get({ key: 'auth_token' });
		return value;
	},

	async setToken(jwt) {
		await Preferences.set({ key: 'auth_token', value: jwt });
	},

	async clearToken() {
		await Preferences.remove({ key: 'auth_token' });
	},

	async clearAll() {
		await Preferences.clear();
	},
};
